<template>
  <LexmeaModal @closed="$emit('closed')">
    <template #title>
      {{ t("entries.deletion.title", { type: entry?.type }) }}
    </template>
    <template #default>
      <h2>{{ t("entries.deletion.are_you_sure", { type: entry?.type }) }}</h2>
      <p
        v-if="showTitle && entry && 'title' in entry"
        class="mt-2 text-center font-bold"
      >
        „{{ entry.title }}“
      </p>
      <slot>
        <p v-if="user" class="mt-4 text-justify">
          {{ t("entries.deletion.restore", { type: entry?.type }) }}
        </p>
      </slot>
    </template>
    <template #footer="{ close }">
      <div class="flex w-full justify-end gap-6 rounded-b bg-white p-6">
        <LexmeaButton class="uppercase" design="link" @click="close">
          {{ t("entries.deletion.abort") }}
        </LexmeaButton>
        <LexmeaButton
          class="uppercase"
          :loading="loading"
          @click="onDelete(close)"
        >
          {{ t("entries.deletion.delete") }}
        </LexmeaButton>
      </div>
    </template>
  </LexmeaModal>
</template>

<script lang="ts" setup>
import type { IUserEntry } from "~/models/IUserEntry";

const { user } = useUserStore();

const props = withDefaults(
  defineProps<{
    entry?: IUserEntry;
    showTitle?: boolean;
  }>(),
  {
    entry: undefined,
    showTitle: true,
  }
);

const emit = defineEmits<{
  closed: [];
  deleted: [];
}>();

const { deleteEntry } = useDeleteEntry();
const loading = ref(false);
const toast = useToast();
const { t } = useI18n();

const onDelete = async (close: () => void) => {
  if (!props.entry) return;
  loading.value = true;
  try {
    await deleteEntry(props.entry);
    emit("deleted");
    close();
  } catch (_) {
    toast.error(t("entries.deletion.failed", { type: props.entry.type }));
  } finally {
    loading.value = false;
  }
};
</script>
